// extracted by mini-css-extract-plugin
export default {"containerIllustration":"_2saIP_9E","col":"_3EhBhamh","hide":"_3lJUJJkL"};